import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import './styles.scss';
import { Translate } from "react-localize-redux";

export class CustomPrivacyDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      privacyClasses: {
        PU: 'privacy-green fa fa-circle',
        MC: 'privacy-yellow fa fa-circle',
        OM: 'privacy-red fa fa-circle',
      },
      privacyOptions: [
        { value: 'PU', classes: 'privacy-green fa fa-circle', text: <Translate id="Public" /> },
        { value: 'MC', classes: 'privacy-yellow fa fa-circle', text: <Translate id="MyContacts" /> },
        { value: 'OM', classes: 'privacy-red fa fa-circle', text: <Translate id="MeOnly" /> },
      ],
    };
  }

  renderDropdownItems(onChange) {
    return this.state.privacyOptions.map(option =>
      <DropdownItem onClick={() => onChange(option.value)}>
        <span className={option.classes}></span> {option.text}
      </DropdownItem>
    );
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  render() {
    const { input: { value, onChange } } = this.props;

    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle caret className="privacy-dropdown-toggle">
          <span className={this.state.privacyClasses[value]}></span>
        </DropdownToggle>
        <DropdownMenu className="privacy-dropdown-menu">
          {this.renderDropdownItems(onChange)}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

const PrivacyDropdown = props => (
  <Field
    label={props.selectLabel}
    name={props.selectName}
    type="text"
    component={CustomPrivacyDropdown}
  />
);

export default PrivacyDropdown;


// WEBPACK FOOTER //
// ./src/components/forms/PrivacyDropdown/PrivacyDropdown.jsx